import { Link, useLocation, useNavigate } from "react-router-dom";
import { GameModeSelector } from "@/components/GameModeSelector";
import { useGameMode } from "@/contexts/GameModeContext";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { clearCachedOverlayState } from "@/components/game/managers/OverlayManager";
import { HamburgerMenu } from "./HamburgerMenu";
export const Header = () => {
  const {
    currentMode
  } = useGameMode();
  const location = useLocation();
  const navigate = useNavigate();
  const isGamePage = location.pathname === "/game";
  const isHomePage = location.pathname === "/";
  const handleHomeClick = () => {
    // Clear any cached overlay state before navigation
    clearCachedOverlayState();
    // Navigate to home page
    navigate("/");
  };
  return <header className="fixed top-0 left-0 right-0 z-[10000] bg-gray-900/95 backdrop-blur-sm border-b border-gray-700 pb-0 mb-0 text-center">
      <div className="px-2 pb-0 mb-0 py-[4px]">
      <div className="flex items-center justify-center relative pb-0 mb-0 mt-0">
        {/* Home button when not on home page */}
        {!isHomePage && <Button variant="ghost" size="icon" className="h-9 w-9 absolute mb-0 pb-0 left-0" onClick={handleHomeClick}>
            <Home className="h-5 w-5 text-gray-400 hover:text-white" />
          </Button>}
        <img src="/lovable-uploads/f8f44bc9-ce01-42f1-98ff-b6aad7a934e9.png" alt="BabbleGram Logo" className="h-9 sm:h-10 pb-0 mb-0" />
        {/* Hamburger menu in top right */}
        <div className="absolute right-0 pb-0 mb-0">
          <HamburgerMenu />
        </div>
      </div>
      {/* Only show the game mode selector on game pages */}
      {isGamePage && <div className="mt-2 flex justify-center">
          <GameModeSelector />
        </div>}
      </div>
    </header>;
};